export default "__VITE_ASSET__nU2whX2Q__"